// extracted by mini-css-extract-plugin
export default {"container":"TabBar_container__k2N7-","buttonRow":"TabBar_buttonRow__1WBjq","row":"TabBar_row__7SXbB","tab":"TabBar_tab__VdTMM","activeTab":"TabBar_activeTab__u6+yR"};